<!--
 * @Author: mazhigang
 * @Date: 2023-04-23 10:45:21
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-16 16:19:47
-->
<template>
  <div id="app" ref="container">
    <router-view />
  </div>
</template>

<script>
// import Watermark from "./utils/watermark";
export default {
  components: {},
  name: "App",
  data() {
    return {};
  },
  created: function() {
    // Watermark.set("水印内容", this.$refs.container);
  },
  watch: {}
};
</script>

<style>
#app {
  transform: scale(1);
  color: #000;
  margin: 0;
  padding: 0;
  border: 0;
  position: relative;
  overflow: hidden;
  font-family: PingFangSC-Regular, PingFang SC;
}
body {
  transform: scale(1);
  margin: 0;
  padding: 0;
  border: 0;
  background: #fff;
  font-family: PingFangSC-Regular, PingFang SC;
}
/* .message-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000; 
} */
</style>



// WEBPACK FOOTER //
// src/App.vue